export default {
    lang: {
        name: 'H-index'
    }
}